import { createStore } from 'satcheljs';
import { IUserViewState } from './schema/IUserViewState';

export const getStore = createStore<IUserViewState>('UserState', {
  active: {},
  errors: {},
  userInvitations: []
});
